/**
 * Indication of how a trade was verified.
 * tag: 1931
 * @readonly
 * @enum {number} (int)
 */
export enum VerificationMethod {
  /** Non-electronic */
  NonElectronic = 0,
  /** Electronic */
  Electronic = 1,
}
